import { Enumify } from 'enumify-ts';
class ConsignmentRatingType extends Enumify() {
    description;
    static DRIVER = new ConsignmentRatingType('From the Driver');
    static SERVICE = new ConsignmentRatingType('From the Customer');
    static _ = ConsignmentRatingType._closeEnum();
    constructor(description) {
        super();
        this.description = description;
    }
}
export default ConsignmentRatingType;
